import { SegmentedControl, Stack, Text } from '@mantine/core';
import type { ProviderAuthMethod } from '@bmai/shared';

interface Props {
    options: ProviderAuthMethod[];
    value: ProviderAuthMethod | null;
    onChange: (value: ProviderAuthMethod) => void;
}

const LABELS: Record<ProviderAuthMethod, string> = {
    ApiKey: 'API key',
    OAuth: 'OAuth',
    ServiceAccount: 'Service account',
    Webhook: 'Webhook',
    AssumedRole: 'AWS IAM role',
    ClientCredentials: 'Client credentials',
};

export default function ConnectionStepChooseAuth({ options, value, onChange }: Props): React.ReactElement {
    return (
        <Stack gap="xs">
            <Text size="sm" c="dimmed">
                Pick how this connection will authenticate. You can't change this later — delete and re-add the connection if you need a different method.
            </Text>
            <SegmentedControl
                value={value ?? options[0]}
                onChange={(v) => onChange(v as ProviderAuthMethod)}
                data={options.map((m) => ({ value: m, label: LABELS[m] }))}
                fullWidth
            />
        </Stack>
    );
}
